(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", () => {
    const accordionDetails = ".js-accordion";
    const accordionSummary = ".js-accordion-summary";
    const accordionContent = ".js-accordion-content";
    const speed = 0.5;

    document.querySelectorAll(accordionSummary).forEach((summary) => {
      const details = summary.closest(accordionDetails);
      const content = details?.querySelector(accordionContent);
      if (!details || !content) return;

      // 初期状態で閉じる
      gsap.set(content, { height: 0, overflow: "hidden", display: "none" });

      // 開く処理
      const openAccordion = () => {
        details.setAttribute("open", "true");
        content.style.display = "block";
        const fullHeight = content.scrollHeight;

        gsap.killTweensOf(content);
        gsap.fromTo(
          content,
          { height: 0, overflow: "hidden" },
          {
            height: fullHeight,
            duration: speed,
            ease: "power2.out",
            onComplete: () => {
              content.style.height = "auto";
              content.style.overflow = "";
              gsap.set(content, { clearProps: "transform" });
            },
          }
        );
      };

      // 閉じる処理
      const closeAccordion = () => {
        gsap.killTweensOf(content);
        const currentHeight = content.scrollHeight;

        gsap.fromTo(
          content,
          { height: currentHeight, overflow: "hidden" },
          {
            height: 0,
            duration: speed,
            ease: "power2.in",
            onComplete: () => {
              details.removeAttribute("open");
              content.style.display = "none";
              content.style.height = "";
              content.style.overflow = "";
              gsap.set(content, { clearProps: "transform" });
            },
          }
        );
        summary.classList.remove("-active");
      };

      // サマリークリックでトグル
      summary.addEventListener("click", (event) => {
        event.preventDefault();
        const isOpen = details.hasAttribute("open");
        summary.classList.toggle("-active", !isOpen);
        isOpen ? closeAccordion() : openAccordion();
      });
    });
  });
})();
